var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  gap: 15px;\n  margin-bottom: 10px;\n"], ["\n  display: grid;\n  gap: 15px;\n  margin-bottom: 10px;\n"])));
export var TextWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n"])));
export var CheckBoxGroupWrapper = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n"], ["\n  display: grid;\n"])));
export var CheckBoxLabel = styled('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 400;\n"], ["\n  font-weight: 400;\n"])));
export var CheckBoxWrapper = styled('div')({
    '&&': {
        '& .MuiFormControlLabel-labelPlacementStart': {
            marginLeft: 0,
            marginRight: 0
        }
    },
    display: 'flex'
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Main.Styles.js.map